import { formatCurrency } from '@if/core/utils'
import { Box, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material'
import { ComputeMechanicalWarrantyResultDto } from '@src/types/ComputeMechanicalWarrantyResultDto'
import { useTranslation } from 'react-i18next'

interface Props {
  computedLoanAmounts: ComputeMechanicalWarrantyResultDto | null,
  isComputing: boolean
}

const MIN_HEIGHT = 195;

const MechanicalWarrantyWorksheetLoanPaymentDetails = ({ computedLoanAmounts, isComputing }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <CardContent>
        <Box minHeight={MIN_HEIGHT} display="flex" flexDirection="column" justifyContent="center">
          {isComputing ? (
            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ minHeight: 40 }}>
              <CircularProgress />
            </Stack>
          ) : computedLoanAmounts ? (
            <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
              <Typography variant="subtitle1">{t('mechanicalWarrantyWorksheet.loanPaymentIs')}</Typography>
              {computedLoanAmounts.paymentAmount !== undefined && computedLoanAmounts.paymentAmount !== null ? (
                <Typography variant="h4" align="center" color="primary" fontWeight="bold">
                  {formatCurrency(computedLoanAmounts.paymentAmount)}
                </Typography>
              ) : null}
              <Typography variant="subtitle1">
                {t('mechanicalWarrantyWorksheet.interestRate', {
                  rate: computedLoanAmounts.interestRate,
                })}
              </Typography>
            </Stack>
          ) : (
            <Typography align="center" color="textSecondary">
              {t('mechanicalWarrantyWorksheet.incompleteForCalculation')}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default MechanicalWarrantyWorksheetLoanPaymentDetails